import { IrreversibleConfirmModal } from 'components/shared/Modals/IrreversibleConfirmModal';
import { useToggle } from 'hooks/useToggle';
import { useCallback } from 'react';
import { DropdownItem } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useClearAll } from 'routes/essential-workspace/components/header/hooks';

export function ClearAllDropdownItem() {
  const clearAll = useClearAll();
  const { isOn: isModalOpened, toggleOff: closeModal, toggleOn: openModal } = useToggle();

  const onConfirmClearAll = useCallback(() => {
    closeModal();
    clearAll();
  }, [clearAll, closeModal]);

  return (
    <>
      <DropdownItem onClick={openModal} className="text-danger" role="menuitem" as="button">
        <FormattedMessage id="clearAll" />
      </DropdownItem>
      <IrreversibleConfirmModal
        onConfirm={onConfirmClearAll}
        isOpen={isModalOpened}
        onClosed={closeModal}
        title={<FormattedMessage id="clearAllTabs" />}
        proceedMessage={<FormattedMessage id="proceedMessage" />}
        description={<FormattedMessage id="tabs.warningMessage" />}
      />
    </>
  );
}
